import axios from '../../axios';
import * as types from '../types';
import { setMsgInfo } from '..';
import filterError from '../common/filterError';
import API from '../api';

const baseUrl = API + '/admin/task_monitor';

export const getAllTaskMonitor = () => {
  return async (dispatch, getState) => {
    dispatch({ type: types.TASK_MONITOR_LOADING });
    try {
      const response = await axios.get(`${baseUrl}/`);
      
      if (response.data && typeof response.data === 'object') {
        if (response.data.results) console.log("Results length:", response.data.results.length);
        if (response.data.data) console.log("Data length:", response.data.data.length);
      }
      
      dispatch({
        type: types.FETCH_TASK_MONITOR_SUCCESS,
        payload: response.data,
      });
      
      return response.data;
    } catch (err) {
      console.error("API call failed:", err);
      const errors = filterError(err);
      dispatch({ type: types.TASK_MONITOR_FAILURE, payload: errors });
      dispatch(
        setMsgInfo({
          success: false,
          msg: errors,
        }),
      );
      throw err;
    }
  };
};

export const getTaskStatistics = (timeframe = '24h') => {
  return async (dispatch) => {
    try {
      const { data } = await axios.get(`${baseUrl}/statistics/?timeframe=${timeframe}`);
      dispatch({
        type: types.FETCH_TASK_STATISTICS_SUCCESS,
        payload: data,
      });
      return data;
    } catch (err) {
      const errors = filterError(err);
      dispatch({ type: types.TASK_STATISTICS_FAILURE, payload: errors });
      throw err;
    }
  };
};

export const getFailedTasks = () => {
  return async (dispatch) => {
    try {
      const { data } = await axios.get(`${baseUrl}/failed_tasks/`);
      dispatch({
        type: types.FETCH_FAILED_TASKS_SUCCESS,
        payload: data,
      });
      return data;
    } catch (err) {
      const errors = filterError(err);
      dispatch({ type: types.FAILED_TASKS_FAILURE, payload: errors });
      throw err;
    }
  };
};

export const cleanupOldTasks = (days = 30) => {
  return async (dispatch) => {
    try {
      const { data } = await axios.delete(`${baseUrl}/cleanup_old_tasks/?days=${days}`);
      dispatch({
        type: types.CLEANUP_TASKS_SUCCESS,
        payload: data,
      });
      return data;
    } catch (err) {
      const errors = filterError(err);
      dispatch({ type: types.CLEANUP_TASKS_FAILURE, payload: errors });
      throw err;
    }
  };
};
